












import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class News extends Vue {
  linkLists = [
    {
      title: '2017多语言冠军挑战赛在京启动',
      link: 'http://xhpfmapi.zhongguowangshi.com/share/index.html?docid=2071744&channel=weixin&from=singlemessage&isappinstalled=0'
    },
    {
      title: '国际多语言冠军挑战赛在中国启动',
      link: 'https://share.jingjiribao.cn/detail/newsDetailShare.html?docid=81147&from=singlemessage&isappinstalled=1'
    },
    {
      title: '国际多语言冠军挑战赛在中国启动',
      link: 'http://msgc.chinareports.org.cn/dfyw/2017/0718/2305.html?from=singlemessage&isappinstalled=1'
    },
    {
      title: '“语保工程”在行动——国际多语言冠军挑战赛绚丽启动',
      link: 'http://edu.china.com.cn/2017-07/18/content_41238489.htm?f=pad'
    },
    {
      title: '国际多语言冠军挑战赛在中国启动',
      link: 'http://jiaoyu.haiwainet.cn/n/2017/0718/c3542392-31025423.html'
    },
    {
      title: '“2017国际多语言冠军挑战赛”在北京启动',
      link: 'http://pic.people.com.cn/n1/2017/0718/c1016-29412619.html?from=singlemessage&isappinstalled=1'
    },
    {
      title: '启动“多语言冠军挑战赛”，全球说联合教科文组织推进语言保护项目',
      link: 'https://www.jiemodui.com/N/81775.html'
    }
  ]
}
